import React from "react";
import { t } from "ttag";

import format from "../../../utils/format";
import { getDinero } from "../../../utils/money";

import styles from "./common.module.scss";

export const ShippingDiscountRow = (props: {
    disableShipping?: boolean;
    disableFreeShippingMessage?: boolean;
    costBeforeDiscountExclTax: string | null;
    costAfterDiscountExclTax: string | null;
}): React.ReactNode => {
    if (props.disableShipping) {
        return null;
    }
    if (
        props.disableFreeShippingMessage &&
        !Number(props.costAfterDiscountExclTax)
    ) {
        return null;
    }
    const preDiscount = getDinero(props.costBeforeDiscountExclTax);
    const postDiscount = getDinero(props.costAfterDiscountExclTax);
    const discount = postDiscount.subtract(preDiscount);
    if (discount.toUnit() >= 0) {
        return null;
    }
    return (
        <span className={styles.line}>
            <li>{t`Shipping Discount`}</li>
            <li>{format.money(discount)}</li>
        </span>
    );
};
